import React from 'react';

import {faTimes} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from '@newsela/angelou';
import {cx} from 'emotion';
import PropTypes from 'prop-types';

import BaseModal from 'components/Modal/Modal';
import {ENTER} from 'constants/keyCodes';

import styles from './styles';

const propTypes = {
  /**
   * Modal title in a string format.
   */
  title: PropTypes.string,

  /**
   * Content that will be rendered as modal's body.
   */
  children: PropTypes.node,

  /**
   * Boolean modal state that determines whether the modal is open or closed.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Callback function invoked when modal is being closed.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * If true, the modal will close by pressing the ESCAPE key.
   */
  closeOnEsc: PropTypes.bool,

  /**
   * If true, clicks outside of the modal will close it.
   */
  closeOnOverlayClick: PropTypes.bool,

  /**
   * Optional custom styling
   */
  classNames: PropTypes.object,
};

const ModalV2 = (props) => {
  const {
    title,
    children,
    open,
    onClose,
    classNames,
  } = props;

  return (
    <BaseModal
      {...props}
      className={cx(styles.container, classNames)}
      open={open}
      onClose={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="dialog_title"
      >
        <section
          className={styles.title}
        >
          <span id="dialog_title">{title}</span>
          <Button
            __classNameFor={{
              root: styles.closeIcon
            }}
            flavor={Button.flavor.incognito}
            onClick={onClose}
            onKeyDown={(event) => (event.key === 'Enter' || event.keyCode === ENTER) && onClose()}
            ariaProps={{
              'aria-label': 'Close'
            }}
          >
            <FontAwesomeIcon icon={faTimes}/>
          </Button>
        </section>
        <section className={styles.body}>
          {children}
        </section>
      </div>
    </BaseModal>
  );
};

ModalV2.propTypes = propTypes;
ModalV2.defaultProps = {
  closeOnOverlayClick: true,
  closeOnEsc: true,
};

export default ModalV2;
